import React from "react";
import BankInfo from "./BankInfo";

interface BankInfoProps {
  banks: any;
  form: any;
}

const BankInfoMother = ({ banks, form }: BankInfoProps) => {
  return (
    <div style={{ padding: "2rem" }}>
      <BankInfo banks={banks} form={form} />
    </div>
  );
};

export default BankInfoMother;
